import { Dropdown } from '@nect/ui/component/dropdown';
import { TextBodyLargeParagraph } from '@nect/ui/component/text';
import { Color } from '@nect/ui/theme/color';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { LeftArrowSVG } from 'src/assets/LeftArrowSVG';
import { DarkButton } from 'src/components/DarkButton';
import { routes } from 'src/constants/constants';
import { getPublicSPID } from 'src/helper/publicSPID';
import styled from 'styled-components';

import { FaqStyled } from '../components/faq/Faq.styled';
import { Footer } from '../components/Footer/Footer';
import { Header } from '../components/Header/Header';
import { extractUrlParam } from '../helper/extractUrlParam';
import { useLocation } from '../react-router-hooks';

const ButtonContainerStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  max-width: 798px;
  margin-top: 48px;
`;

export const FaqSelectionScreen = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { location } = useLocation();
  const [paramsState, setParamsState] = useState<any>();
  const [selectedCustomer, setSelectedCustomer] = useState<string>();
  const { navigate } = useLocation();

  useEffect(() => {
    const element = document.getElementById(id);

    if (!element) {
      return;
    }

    const top = element.offsetTop - 100;
    window.scroll({ top, behavior: 'auto' });
  }, [id]);

  useEffect(() => {
    if (!location.state || !location.state.uuid) {
      const url = location.search;
      setParamsState({
        uuid: extractUrlParam({ url, type: 'uuid' }),
        model: extractUrlParam({ url, type: 'model' }),
        appVersion: extractUrlParam({ url, type: 'appVersion' }),
        systemVersion: extractUrlParam({ url, type: 'systemVersion' }),
        customer: extractUrlParam({ url, type: 'customer' })
      });
    } else {
      setParamsState(location.state);
    }
  }, [location]);

  const items = [
    {
      icon: <img width={24} src={require('../assets/customer/HEK.svg')} />,
      value: 'Hanseatische Krankenkasse',
      id: 'hanseatische-krankenkasse',
      publicSPID: '15017106457168956497'
    },
    {
      icon: <img width={24} src={require('../assets/customer/HUK.svg')} />,
      value: 'HUK-Coburg',
      id: 'huk-coburg',
      publicSPID: '18292802182886008010'
    },
    {
      icon: (
        <img width={24} src={require('../assets/customer/Hallesche.svg')} />
      ),
      value: 'Hallesche Krankenversicherung',
      id: 'hallesche-krankenversicherung',
      publicSPID: '16922744190611413871'
    },
    {
      icon: <img width={24} src={require('../assets/customer/ADAC.svg')} />,
      value: 'ADAC',
      id: 'adac',
      publicSPID: '9668622801830922673'
    },
    {
      icon: <img width={24} src={require('../assets/customer/IFB.svg')} />,
      value: 'Hamburgische Investitions- und Förderbank',
      id: 'hamburgische-investitions-und-foerderbank',
      publicSPID: '16455975703651300945'
    },
    {
      icon: <img width={24} src={require('../assets/customer/BA.svg')} />,
      value: 'Bundesagentur für Arbeit',
      id: 'bundesagentur-fuer-arbeit',
      publicSPID: '6221269934062709210'
    },
    {
      icon: <img width={24} src={require('../assets/customer/onlogist.svg')} />,
      value: 'Onlogist',
      id: 'onlogist',
      publicSPID: '10312661242435406034'
    }
  ];

  useEffect(() => {
    const publicSPID = getPublicSPID();

    const selectedSP = items.find(item => item.publicSPID === publicSPID);

    if (selectedSP) {
      navigate(routes.FAQCUSTOMER.replace(':id', selectedSP.id));
    }
  }, []);

  return (
    <div className="root">
      <Header />
      <div id="main" className="main">
        <FaqStyled.NavigationMainContainer>
          <FaqStyled.NavigationContainer>
            <img src={require('../assets/faqhome.svg')} />
            <FaqStyled.NavigationText
              to={{ pathname: routes.HOME, state: paramsState }}
            >
              {t('Start ')}
            </FaqStyled.NavigationText>
          </FaqStyled.NavigationContainer>
        </FaqStyled.NavigationMainContainer>

        <FaqStyled.ContainerMain id="main" style={{ marginTop: 60 }}>
          <FaqStyled.Container>
            <TextBodyLargeParagraph
              style={{ marginTop: 8, marginBottom: 32 }}
              color={Color.grey600}
            >
              {t('Please let us know which partner company you identify for.')}
            </TextBodyLargeParagraph>
            <Dropdown
              // @ts-ignore
              label={t('Name of the company')}
              placeholder={t('Please type here or select')}
              items={items}
              // @ts-ignore
              onChange={item => setSelectedCustomer(item?.id as string)}
            />
          </FaqStyled.Container>

          <ButtonContainerStyled>
            <DarkButton
              style={{
                background: 'white',
                color: '#0A0D1B',
                border: 'solid 1px #0A0D1B'
              }}
              onClick={() => {
                window.history.back();
              }}
            >
              <LeftArrowSVG
                style={{
                  transform: 'rotate(-180deg)',
                  color: '#0A0D1B',
                  marginRight: 6,
                  marginLeft: 0
                }}
              />
              {t('Back')}
            </DarkButton>
            <DarkButton
              onClick={() => {
                if (selectedCustomer) {
                  navigate(routes.FAQCUSTOMER.replace(':id', selectedCustomer));
                }
              }}
            >
              {t('Continue')}
              <LeftArrowSVG />
            </DarkButton>
          </ButtonContainerStyled>
        </FaqStyled.ContainerMain>
      </div>
      <Footer />
    </div>
  );
};
